export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const errMsg = (err, fallback = "Something went wrong") => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (typeof d === "object") return d.message || fallback;
  return fallback;
};

export const initials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() || "")
    .join("") || "?";

export const statusMeta = (p) => {
  const cs = p?.contribution_status;
  const s = p?.status;
  if (cs === "confirmed" || s === "funded" || s === "paid")
    return { label: "Paid", tone: "success" };
  if (s === "covering") return { label: "Covering", tone: "info" };
  if (cs === "pending" || s === "paying") return { label: "Paying…", tone: "warn" };
  return { label: "Pending", tone: "muted" };
};
